import React from 'react';
import styled from 'styled-components';
import { Grid } from 'layout-core-components';
import env from 'bench-environment';
import { Spinner } from 'spinner';
import formatCurrency from 'format-currency';
import { colors } from 'bench-style-constants';

import { NotebookIcon } from './Icons';
import DataEntries from './DataEntries';
import DateFormatter from './DateFormatter';
import SidebarCard from './SidebarCard';
import { DataEntry } from './types';

const Date = styled.div`
  color: ${colors.dust};
  font-size: 12px;
`;

const IconLinksWrapper = styled.div`
  color: ${colors.water};
`;

const Currency = styled.div`
  font-weight: bold;
  margin-bottom: 8px;
`;

const SpinnerWrap = styled.div`
  padding: 16px 0;
  text-align: center;
`;

type TransactionInfoCardProps = {
  id: string;
  clientId: string;
  vendor: string;
  amount: number;
  documentDate: string;
  dataEntries: DataEntry[];
  loading: boolean;
  error: string;
};

const TransactionInfoCard = ({
  id,
  clientId,
  vendor,
  amount,
  documentDate,
  dataEntries,
  loading,
  error,
}: TransactionInfoCardProps) => {
  const duiUrl = `${env.location.bkTools}/${clientId}/document-entry/${id}/single`;

  if (loading || error) {
    return (
      <SidebarCard>
        {loading && (
          <SpinnerWrap>
            <Spinner />
          </SpinnerWrap>
        )}
        {error && <div>{error}</div>}
      </SidebarCard>
    );
  }

  return (
    <SidebarCard>
      <Grid row="1fr auto">
        <Date>
          <DateFormatter text={documentDate} inputFormat="MM/DD/YYYY" />
        </Date>
        <IconLinksWrapper>
          <Grid row="auto auto">
            <a href={duiUrl} target="_blank" rel="noreferrer noopener">
              <NotebookIcon />
            </a>
          </Grid>
        </IconLinksWrapper>
      </Grid>

      <Grid column="auto auto">
        <div>{vendor}</div>
        <Currency>{formatCurrency(amount)}</Currency>
      </Grid>

      <DataEntries data={dataEntries} />
    </SidebarCard>
  );
};

TransactionInfoCard.defaultProps = {
  id: '',
  clientId: '',
  vendor: '',
  amount: 0,
  documentDate: '',
  dataEntries: [],
};

export default TransactionInfoCard;
